<template>
    <div class="sourceOfCase" style="overflow-y: scroll;">
        <div style="padding: 20px;">
            <h1>案源点击量</h1>
            <div class="switchNew">
                <a href="javascript:;" @click="countUserDay()">
                    <div class="inline-block"><div class="inline-block sevendays"></div>
                        <p class="inline-block people">近30天案源点击量</p>
                    </div>
                </a>
                <a href="javascript:;" @click="CountUserWeek()">
                    <div class="inline-block" style="margin: 0 30px">
                        <div class="inline-block sevendays" style="background-color: #e1604e"></div>
                        <p class="inline-block people">近30周案源点击量</p>
                    </div>
                </a>
                <a href="javascript:;">
                    <div @click="CountUserMonth()" class="inline-block">
                        <div class="inline-block sevendays" style="background-color: #675bba"></div>
                        <p class="inline-block people">
                            <select style=" width: 170px;" id="status_select" name="">
                                <option value="0">2019年月案源点击量</option>
                            </select>
                        </p>
                    </div>
                </a>
            </div>
            <div class="inline-block" id="numberDay" :style="{width: '100%', height: '500px'}"></div>
            <!--拨打电话-->
            <h1>案源拨打电话</h1>
            <div class="switchNew">
                <a href="javascript:;" @click="CallUserDay()">
                    <div class="inline-block"><div class="inline-block sevendays"></div>
                        <p class="inline-block people">近30天案源拨打电话</p>
                    </div>
                </a>
                <a href="javascript:;" @click="CallUserWeek()">
                    <div class="inline-block" style="margin: 0 30px">
                        <div class="inline-block sevendays" style="background-color: #e1604e"></div>
                        <p class="inline-block people">近30周案源拨打电话</p>
                    </div>
                </a>
                <a href="javascript:;">
                    <div @click="CallUserMonth()" class="inline-block">
                        <div class="inline-block sevendays" style="background-color: #675bba"></div>
                        <p class="inline-block people">
                            <select style=" width: 170px;" id="status_select" name="">
                                <option value="0">2019年月案源拨打电话</option>
                            </select>
                        </p>
                    </div>
                </a>
            </div>
            <div class="inline-block" id="callUserDayid" :style="{width: '100%', height: '500px'}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sourceOfCase",
        data () {
            return {
                dayListData : [],
                numberDay : {},
                callUserDayData : [],
                callUserDayid : {},
            }
        },
        methods :{
            countUserDay : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/countUserDay',
                    success: function (res) {
                        _this.dayListData = res.List
                        _this.dayData(1)
                        console.log(res )
                    }
                })
            },
            CountUserWeek : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CountUserWeek',
                    success: function (res) {
                        _this.dayListData = res.List
                        _this.dayData(2)
                        console.log(res )
                    }
                })
            },
            CountUserMonth : function(){
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CountUserMonth',
                    success: function (res) {
                        _this.dayListData = res.List
                        _this.dayData()
                        console.log(res )
                    }
                })
            },
            dayData : function (type) {
                var _this = this
                var law_day = []
                var dateOne = []
                if(type == 1){
                    for(var i in _this.dayListData){
                        law_day.push(_this.dayListData[i])
                        dateOne.push(i)
                    }
                    var _colour = '#5793f3'
                }if(type == 2){
                    for(var i in _this.dayListData){
                        law_day.push(_this.dayListData[i])
                        dateOne.push(i)
                    }
                    var _colour = '#e1604e'
                }if(type == undefined){
                    for(var i in _this.dayListData){
                        for (var index in _this.dayListData[i]){
                            law_day.push(_this.dayListData[i][index])
                            dateOne.push(index)
                            law_day.splice(12,12);
                            dateOne.splice(12,12);
                        }

                    }
                    var _colour = '#675bba'
                }
                console.log(law_day)
                var colors = [_colour];
                //
                _this.numberDay = this.$echarts.init(document.getElementById('numberDay'))
                _this.numberDay.setOption({
                    color: colors,
                    tooltip: {
                        trigger: 'none',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    grid: {
                        top: 70,
                        bottom: 50
                    },
                    title : {
                        text: '案源点击量（天/周/月）',
                        x:'left',
                    },
                    xAxis: [
                        {
                            name: '日期',
                            type: 'category',
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine: {
                                onZero: false,
                                lineStyle: {
                                    color: colors[0]
                                }
                            },
                            axisPointer: {
                                label: {
                                    formatter: function (params) {
                                        return  params.value + '新增案源点击量'
                                            + (params.seriesData.length ? '：' + params.seriesData[0].data : '')+'人  ';
                                    }
                                }
                            },
                            data: dateOne
                        }
                    ],
                    yAxis: [
                        {
                            name: '人数',
                            type: 'value',
                            minInterval:1,
                        }
                    ],
                    series: [
                        {
                            type:'line',
                            // smooth: true,
                            smooth: false,
                            data: law_day,
                            label: {//top的数值
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        }
                    ]
                })
            },
        //    拨打电话
            CallUserDay : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CallUserDay',
                    success: function (res) {
                        _this.callUserDayData = res.List
                        _this.telephone(1)
                        console.log(res)
                    }
                })
            },
            CallUserWeek : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CallUserWeek',
                    success: function (res) {
                        _this.callUserDayData = res.List
                        _this.telephone(2)
                        console.log(res )
                    }
                })
            },
            CallUserMonth : function(){
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/CallUserMonth',
                    success: function (res) {
                        _this.callUserDayData = res.List
                        _this.telephone()
                        console.log(res )
                    }
                })
            },
            telephone : function (type) {
                var _this = this
                var law_day = []
                var dateOne = []
                if(type == 1){
                    for(var i in _this.callUserDayData){
                        law_day.push(_this.callUserDayData[i])
                        dateOne.push(i)
                    }
                    var _colour = '#5793f3'
                }if(type == 2){
                    for(var i in _this.callUserDayData){
                        law_day.push(_this.callUserDayData[i])
                        dateOne.push(i)
                    }
                    var _colour = '#e1604e'
                }if(type == undefined){
                    for(var i in _this.callUserDayData){
                        for (var index in _this.callUserDayData[i]){
                            law_day.push(_this.callUserDayData[i][index])
                            dateOne.push(index)
                            law_day.splice(12,12);
                            dateOne.splice(12,12);
                        }

                    }
                    var _colour = '#675bba'
                }
                console.log(law_day)
                var colors = [_colour];
                //
                _this.callUserDayid = this.$echarts.init(document.getElementById('callUserDayid'))
                _this.callUserDayid.setOption({
                    color: colors,
                    tooltip: {
                        trigger: 'none',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    grid: {
                        top: 70,
                        bottom: 50
                    },
                    title : {
                        text: '案源拨打电话（天/周/月）',
                        x:'left',
                    },
                    xAxis: [
                        {
                            name: '日期',
                            type: 'category',
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine: {
                                onZero: false,
                                lineStyle: {
                                    color: colors[0]
                                }
                            },
                            axisPointer: {
                                label: {
                                    formatter: function (params) {
                                        return  params.value + '新增案源拨打电话'
                                            + (params.seriesData.length ? '：' + params.seriesData[0].data : '')+'人  ';
                                    }
                                }
                            },
                            data: dateOne
                        }
                    ],
                    yAxis: [
                        {
                            name: '人数',
                            type: 'value',
                            minInterval:1,
                        }
                    ],
                    series: [
                        {
                            type:'line',
                            // smooth: true,
                            smooth: false,
                            data: law_day,
                            label: {//top的数值
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        }
                    ]
                })
            }
        },
        mounted () {
            this.countUserDay()
            this.CallUserDay()
        }
    }
</script>

<style scoped>
    .frequency {box-shadow: 1px 1px 5px #e0e0e0;font-size: 18px;line-height: 35px;border: 1px solid #e0e0e0;margin:10px 20px 10px 20px;display: inline-block;}
    .number {margin-right: 45px;color: red;}
    .sevendays {width: 20px;height: 20px;background-color: rgb(87, 147, 243);}
    .people {vertical-align: top;margin-top: -1px;margin-left: 9px;color: rgb(0, 0, 0);}
    .lvwa_texe {width: 100%;border-bottom: 1px solid rgb(202, 202, 202);height: 30px;line-height: 30px;text-align: center;}
    .lvwa_texe div {width: 33%;}
    .jump_page {width: 50px;height: 30px;border: solid 1px rgb(202, 202, 202);border-radius: 4px;text-align: center;margin: 0 4px 0 10px;}
    .lvwa_texe1 {width: 100%;border-bottom: 1px solid rgb(202, 202, 202);height: 30px;line-height: 30px;text-align: center;}
    .lvwa_texe1 div {
        width: 22%;
        white-space: nowrap;
        overflow: hidden;
    }
    .vertical-center-modal{display: flex;align-items: center;justify-content: center;}
</style>
